import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { useFetch } from '../../hooks/useFetch';
import { userApi } from '../../api/user';
import { reset } from '../../redux/userSlice';

import FormContainer from '../../components/UI/FormContainer';
import { AddressField, Field } from '../../components/UI/Form';
import Button from '../../components/UI/Button';

const Container = styled.div`
	width: 90%;
	max-width: 900px;
	display: flex;
	flex-direction: column;
	padding-top: 30px;
    align-items: center;
    gap: 50px;
`;

const ButtonsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 20px;
    justify-content: center;
`;


export default function MyInfo(props) {
    const [isEdibleMode, setIsEdibleMode] = React.useState(false);

    if(isEdibleMode) {
        return <EditableInfo setIsEdibleMode={ setIsEdibleMode }/>;
    }
    
    return <NonEditableInfo setIsEdibleMode={ setIsEdibleMode }/>;
}

function NonEditableInfo(props) {
    const { data, loading, error } = useFetch(userApi.getUserInfo, []);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    if(loading) {
        return ;
    }

    if(error) {
        alert('사용자 정보 로드에 실패했습니다.');
        navigate('/');
        return ;
    }

    const onClickEdit = () => {
        props.setIsEdibleMode(true);
    }

    const onClickWithdrawal = () => {
        if(window.confirm('탈퇴 후에는 데이터 복구가 어려울 수 있습니다. 정말 탈퇴하시겠습니까?')) {
            userApi.withdrawUser().then((response) => {
                alert('탈퇴처리되었습니다.');
                dispatch(reset());
                navigate('/');
            })
            .catch((error) => {
                alert('탈퇴에 실패했습니다. 다시 시도해 주세요.');
            });
        }
    }

    return (
        <Container>
            <FormContainer style={{ border: 'none' }}>
                <Field title="아이디" value={ data.id } />
                <Field title="비밀번호" value={ "●●●●●" } />
                <Field title="이메일" value={ data.email } />
                <Field title="이름" value={ data.name } />
                <Field title="연락처" value={ data.contact.replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`) } />
                <Field title="주소" value={ [ data.postalCode, data.roadAddress, data.detailAddress ] } />
            </FormContainer>
            <ButtonsWrapper>
                <Button buttonText="정보수정" onClick={ onClickEdit }/>
                <Button buttonText="회원탈퇴" onClick={ onClickWithdrawal }/>
            </ButtonsWrapper>
        </Container>
    );
}

function EditableInfo(props) {
    const { data, loading, error } = useFetch(userApi.getUserInfo, []);
    const navigate = useNavigate();
    const [formData, setFormData] = React.useState({
        contact: '',
        password: null,
        confirmPassword: null,
        postalCode: '',
        roadAddress: '',
        detailAddress: ''
    });

    useEffect(() => {
        if(data) {
            setFormData({
                contact: data.contact || '',
                password: null,
                confirmPassword: null,
                postalCode: data.postalCode || '',
                roadAddress: data.roadAddress || '',
                detailAddress: data.detailAddress || ''
            });
        }
    }, [data]); 

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleChangeAddress = ({postalCode, roadAddress}) => {
        setFormData({
            ...formData,
            postalCode,
            roadAddress
        });
    }

    const handleSubmit = () => {
        if(formData.password) {
            // 비밀번호 유효성 검사 - 영문, 숫자 조합 5자 이상
            const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{5,}$/;
            if(!passwordRegex.test(formData.password)) {
                alert('비밀번호는 영문과 숫자 조합으로 5자 이상이어야 합니다.');
                return;
            }
            if(formData.password !== formData.confirmPassword) {
                alert('비밀번호가 일치하지 않습니다.');
                return;
            }
        }

        userApi.updateUserInfo(formData);
        props.setIsEdibleMode(false);
    };

    if(loading) {
        return ;
    }

    if(error) {
        alert('사용자 정보 로드에 실패했습니다.');
        navigate('/my/info');
        return ;
    }
    
    return (
        <Container>
            <FormContainer style={{ border: 'none' }}>
                <Field title="아이디" value={ data.id } />
                <Field title="비밀번호" type="password" $placeholder="영문, 숫자 조합 5자 이상"
                    name="password" value={ formData.password }
                    onHandleChange={ handleChange }
                />
                <Field title="비밀번호 확인" type="password" $placeholder=""
                    name="confirmPassword" value={ formData.confirmPassword }
                    onHandleChange={ handleChange }
                />
                <Field title="이메일" value={ data.email } />
                <Field title="이름" value={ data.name } />
                <Field title="연락처" type="tel" $placeholder='"-"없이 입력해 주세요.'
                    name="contact" value={ formData.contact }
                    onHandleChange={ handleChange }
                />
                <AddressField
                    value={{ postalCode: formData.postalCode, roadAddress: formData.roadAddress, detailAddress: formData.detailAddress }}
                    onHandleChange={ handleChange }
                    onAddressComplete={ handleChangeAddress }
                />
            </FormContainer>
            <ButtonsWrapper>
                <Button buttonText="수정완료" onClick={ handleSubmit }/>
            </ButtonsWrapper>
        </Container>
    );
}